export default __webpack_public_path__ + "static/media/nodejs.bef1b682.png";